import { IconProps } from "../../utils/global-types/global-types";

const UnorderedListIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-[18px] h-[18px]"}
      {...rest}
    >
      <g fill="currentColor" clipPath="url(#clip0_9118_141990)">
        <path d="M3.167 5.5a1.167 1.167 0 1 0 0-2.333 1.167 1.167 0 0 0 0 2.333M3.167 10.167a1.167 1.167 0 1 0 0-2.334 1.167 1.167 0 0 0 0 2.334M3.167 14.833a1.167 1.167 0 1 0 0-2.333 1.167 1.167 0 0 0 0 2.333M6.667 4.917h8.75a.583.583 0 1 0 0-1.167h-8.75a.583.583 0 1 0 0 1.167M15.417 8.417h-8.75a.583.583 0 1 0 0 1.166h8.75a.583.583 0 1 0 0-1.166M15.417 13.083h-8.75a.583.583 0 1 0 0 1.167h8.75a.583.583 0 1 0 0-1.167"></path>
      </g>
      <defs>
        <clipPath id="clip0_9118_141990">
          <path fill="#fff" d="M2 2h14v14H2z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default UnorderedListIcon;
